import './style.css';
import { ImageSize, useResponsiveImage } from '@/utils/useResponsiveImage';
import classNames from 'classnames';
import { CenteredCoverImage } from '../CenteredCoverImage';

interface CardProps {
  title: string;
  titleExtra?: string;
  tags?: React.ReactNode;
  description?: string;
  descriptionHtml?: React.ReactNode;
  author?: string;
  prefixAuthor?: string;
  link?: string;
  button?: React.ReactNode;
  imageSize?: ImageSize;
  noImage?: boolean;
  linkText?: string;
  progress?: number;
  image?: {
    url: string;
    alternativeText: string;
  };
  bookmarkButton?: React.ReactNode;
}
export default function Card({
  titleExtra,
  title,
  tags,
  description,
  progress,
  descriptionHtml,
  author,
  prefixAuthor = 'By ',
  image,
  noImage = false,
  button,
  imageSize = 'medium',
  bookmarkButton,
}: CardProps) {
  const { src: imageSrc } = useResponsiveImage(image, imageSize);

  return (
    <div
      key={title}
      className={classNames(
        `card group h-full overflow-hidden rounded-2xl border border-primary-500 bg-white hover:border-primary-600`,
        {
          'min-h-[402px] lg:max-w-[414px]': !noImage,
        },
      )}>
      {!noImage && <CenteredCoverImage src={imageSrc} alt={image?.alternativeText || ''} />}
      <div className="rows-span-1 relative flex flex-col items-start p-5 pt-7">
        {titleExtra && <span className="mb-1 font-haffer text-sh-16-32 font-bold">{titleExtra}</span>}
        <p className={`font-haffer text-sh-28-32 font-bold `}>{title}</p>
        <div className="mt-2 flex w-full justify-between">
          {tags}
          {bookmarkButton ? bookmarkButton : null}
        </div>

        {descriptionHtml ? descriptionHtml : <p className="line-clamp-4 font-haffer text-sh-16-24">{description}</p>}
        {author && (
          <p className="text-sh-14-20 text-sh-grey-4e">
            {prefixAuthor} <strong>{author}</strong>
          </p>
        )}
        {progress && progress > 0 ? (
          <div className="mt-4 h-[6px] w-full rounded-full bg-[#2073D333]/20">
            <div
              className="h-[6px] rounded-full bg-[#488FE3]"
              style={{ width: `${progress <= 100 ? progress : 100}%` }}></div>
          </div>
        ) : null}
        {button && <div className="rows-span-1 mt-sh-15 flex flex-col items-start gap-1">{button}</div>}
      </div>
    </div>
  );
}
